export const collegiateApiUrl = 'https://collegebowlingseasonapi-test.azurewebsites.net';
export const searchServiceUrl = 'https://qawebservices.bowl.com/USBC.Search.Services';
export const ssoUrl = "https://qasignon.bowl.com";
export const siteUrl = "https://testcollegebowlingtournament.bowl.com";
export const clientId = "COLLEGIATERANKING_CLIENT_9208B74D-C5FD-47B9-8C68-6E5CA3B9E903";
export const apiScope = "COLLEGIATERANKING_APIKEY_06AB4276-3C7F-443E-BF99-9A2E73C531BD  Catapult.CollegiateApi Usbc.Web.Profile";
export const ssoProfileUrl = "https://signon.bowl.com/Manage?clientId=COLLEGIATERANKING_CLIENT_9208B74D-C5FD-47B9-8C68-6E5CA3B9E903";


// WEBPACK FOOTER //
// ./src/config/constants.Testing.js